import {useDeliveryStore} from "@/Stores/Site/DeliveryStore";
import {declOfNum} from "@/shared/lib/number/declOfNum";
import {Link} from "@/shared/ui/Link";
import {DeliveryItem} from "../types";
import styles from "./ProductDelivery.module.scss";

type Props = {
    item: DeliveryItem;
    productDataId: number;
};

export const ProductDeliveryAction = (
    {
        item,
        productDataId
    }: Props
) => {
    const openModalDeliveryInformation = useDeliveryStore(state => state.openModalDeliveryInformation);

    switch (item.key) {
        case "brandShop":
            return (
                <>
                    Забрать&nbsp;из&nbsp;
                    <button
                        type={`button`}
                        className={styles.count}
                        onClick={() => openModalDeliveryInformation("brandShop", [{productDataId}])}
                    >
                        {item.count}
                        {declOfNum(item.count ?? 0, [' магазина', ' магазинов', ' магазинов'])}
                    </button>
                </>
            );

        case "pvz":
            return (
                <>
                    Самовывоз&nbsp;из&nbsp;
                    <button
                        type={`button`}
                        className={styles.count}
                        onClick={() => openModalDeliveryInformation("pvz", [{productDataId}])}
                    >
                        {item.count}
                        {declOfNum(item.count ?? 0, [' пункта', ' пунктов', ' пунктов'])}
                    </button>
                </>
            );

        case "courier":
            return (
                <Link href={`/delivery#delivery`} className={styles.link}>Курьер</Link>
            );

        default:
            return null;
    }
};
